export default __webpack_public_path__ + "static/media/alert-icon.8defd63d.svg";